export default __webpack_public_path__ + "media/zurb/img/legacy/spur/blur-b132b8e0bca91eb68cdd1a7be47885ad.jpg";